import React from 'react';
import styled from 'styled-components';
import BubbleMenu from './components/BubbleMenu';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import SocialMedia from './components/SocialMedia';
import Contact from './components/Contact';
import './App.css';

const AppContainer = styled.div`
  background-color: #faf8f5;
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
`;

function App() {
  return (
    <AppContainer>
      <BubbleMenu
        logo={<span style={{ fontWeight: 600 }}>S</span>}
        menuAriaLabel="Toggle navigation"
        menuBg="#ffffff"
        menuContentColor="#111111"
        useFixedPosition={true}
        animationEase="back.out(1.5)"
        animationDuration={0.5}
        staggerDelay={0.12}
      />
      <div id="home">
        <Hero />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="portfolio">
        <Portfolio />
      </div>
      <div id="social">
        <SocialMedia />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </AppContainer>
  );
}

export default App;
